// This index file is provided to smooth over the transition from a single
// util.js to a directory of distinct Contentful Component utils. New code
// should import directly from specific files.

export { default as stringSubstitution } from './template-strings';
export { default as componentSubstitution } from './component-template-string';
export { default as MetaTags } from './meta-tags';
